<template>
  <el-form-item :label="label">
    <el-input-number
      v-model="myValue"
      size="mini"
      :min="min"
      :max="max"
    ></el-input-number>
    <span style="margin-left: 6px; color: #a2b1cb; font-size: 12px"
      >({{ unit }})</span
    >
  </el-form-item>
</template>
<script>
export default {
  props: {
    unit: {
      type: String,
      default: "km/h",
    },
    label: {
      type: String,
      default: "",
    },
    value: {
      type: Number,
      default: 5,
    },
    min: {
      type: Number,
      default: 5,
    },
    max: {
      type: Number,
      default: 100,
    },
  },
  data() {
    return {
      myValue: this.value
    };
  },
  watch: {
    value(val) {
      this.myValue = val;
    },
    myValue() {
      this.$emit("input", this.myValue);
    },
  },
};
</script>
